module.exports = __webpack_public_path__ + "img/motor_no68.5a9d550d.jpg";